import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BackendService } from '@wilson/base';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { Profession } from '@wilson/interfaces';

@Injectable({
  providedIn: 'root',
})
export class ProfessionGateway extends BackendService<Profession> {
  protected readonly http = inject(HttpClient);
  protected readonly config = inject<ConfigOptions>(ConfigService);

  protected readonly path = 'professions';
}
